import { render, staticRenderFns } from "./SharedDrives.vue?vue&type=template&id=51a90949"
import script from "./SharedDrives.vue?vue&type=script&lang=js"
export * from "./SharedDrives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports